import  "./header.scss"
import logo from "../../assets/images/logo.svg"
import { Link } from "react-scroll"
import { useEffect, useState } from "react";

export default function Header({openModal}) {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Check if the scroll position is greater than 100px
      if (window.scrollY > 100) {
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <header className={`header_wrapper ${isActive ? "active" : ""}`}>
        <div className="container flex">
          <Link
            to="home"
            spy={true}
            smooth={true}
          >
            <img src={logo} alt="logo"/>
          </Link>
          <button
            onClick={openModal}
            className="simple_btn"
          >
            Contact
          </button>
        </div>
      </header>
    </>
  )
}